<script lang="ts">
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import Fa from 'svelte-fa'
    import { faEdit, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import { AppointmentItem } from '../../modules/schedulerApi/appointments/appointment-item'
    import ServiceSelect_2 from '../pos/service-select-2.svelte'
    import { User } from '../../modules/usersApi/users/user'
    import { AppointmentResource } from '../../modules/schedulerApi/appointments/appointment-resource'
    import Zbutton from '../_common/z/zbutton.svelte'
    const dispatch = createEventDispatcher()

    let className: string = ''
    export { className as class }
    export let appointmentResource: AppointmentResource = undefined
    export let locked: string[] = []

    let step = 1
    let isNew = false

    $: isLocked = !!appointmentResource?.resourceLock && (locked || []).includes(appointmentResource.resourceLock.resourcesLockId)

    async function editEntity() {
        step = 2
        // o pai recarrega a lista de ocupados antes de o seletor ser usado
        dispatch('edit')
    }

    async function newEntity() {
        appointmentResource = new AppointmentResource()
        isNew = true
        step = 2
    }

    async function cancelEntity() {
        appointmentResource = undefined
        step = 1
        dispatch('cancel')
    }

    async function confirmEntity() {
        if (!validateFields()) return
        dispatch('added', appointmentResource)
        if (isNew) appointmentResource = undefined
        step = 1
        isNew = false
    }

    function validateFields() {
        if (!appointmentResource.resourceLock) {
            evaluateError('Informe uma sala/equipamento')
            return false
        }
        if (isLocked) {
            evaluateError('Esta sala/equipamento já está em uso por outro agendamento neste horário.')
            return false
        }
        return true
    }

    function evaluateError(error) {
        window.error(error)
    }

    onMount(() => {
        if (!appointmentResource) newEntity()
    })
</script>

{#if appointmentResource !== undefined}
    {#if step === 1}
        <div class="row line item-static {className}">
            <div class="col-md-11 nowrap">
                {appointmentResource.resourceLock.label}
                {#if isLocked}<span class="zbadge_default zbadge_danger ms-2">em uso por outro agendamento neste horário</span>{/if}
            </div>
            <div class="col-md-1 text-end">
                <Zbutton label="Editar" on:click={editEntity}></Zbutton>
            </div>
        </div>
    {/if}
    {#if step === 2}
        <div class="edit-outer" />
        <div class="row line {className} edit-form">
            <div class="col-md-10 mb-2 mb-md-0">
                <ZentitySelect fonte="recurso" params={{ ocupados: locked }} bind:value={appointmentResource.resourceLock} />
            </div>
            <div class="col-md-2 d-flex">
                <div class="spacer h-mobile" />
                <Zbutton class="me-2" color="red" icon={faTrashAlt} on:click={cancelEntity}></Zbutton>
                <Zbutton color="primary" label="Confirmar" icon={faCheck} on:click={confirmEntity}></Zbutton>
            </div>
        </div>
    {/if}
{/if}

<style>
    @media (max-width: 900px) {
        .item-static button {
            margin-top: 6px !important;
            margin-bottom: 8px !important;
        }
        .edit-form {
            z-index: 1;
            position: relative;
            background: #00000050;
            border-radius: 4px;
        }
        .edit-outer {
            position: absolute;
            top: 0px;
            left: 0px;
            height: 100vh;
            width: 100vw;
            background: #99999999;
            z-index: 0;
        }
    }
</style>
